<!-- View DialogPassOutOfUsingTimeWarning -->
<template>
  <ItemDialog ref="passOutOfUsingTimeWarning" image-type="alert">
    <template #content-area>
      <div class="text-caution">
        <h1>
          <strong>利用可能時間外です</strong>
        </h1>
      </div>
      <div v-if="masterBook.id != 832" class="text-center">
        <p>{{ dateMessage }}の利用可能時間は</p>
        <p>{{ periodTimeMessage }}</p>
      </div>
      <div v-else class="text-center">
        <p>平日の利用可能時間は</p>
        <p>9:00から17:00です。</p>
      </div>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";
import moment from "@/services/moment";
import { useStore } from "vuex";

export default {
  name: "DialogPassOutOfUsingTimeWarning",
  props: {
    okButtonClicked: {
      type: Function,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const store = useStore();
    const passOutOfUsingTimeWarning = ref(null);

    const periodTimeMessage = ref("");
    const dateMessage = ref("");

    const masterBook = store.getters["ticketing/masterBook"];

    const openDialog = (pass) => {
      periodTimeMessage.value = `${moment(
        new Date(`${pass.using_window[0].using_started_at}`)
      ).format("HH:mm")}から${moment(
        new Date(`${pass.using_window[0].using_limited_at}`)
      ).format("HH:mm")}です。`;

      dateMessage.value = moment(
        new Date(`${pass.using_window[0].using_started_at}`)
      ).format("MM/DD");

      passOutOfUsingTimeWarning.value.open();
    };

    const closeDialog = () => {
      if (props.okButtonClicked != null) {
        props.okButtonClicked();
      } else {
        passOutOfUsingTimeWarning.value.close();
      }
    };

    return {
      passOutOfUsingTimeWarning,
      periodTimeMessage,
      dateMessage,
      openDialog,
      closeDialog,
      masterBook,
    };
  },
};
</script>

<style scoped lang="scss">
.text-center {
  text-align: center;
  font-size: 3vw;
}

.text-caution {
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: bold;
  font-size: 4vw !important;
}
</style>
